import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { trackByLabel } from 'v2/modules/shared/util/track-by.util';

import { IOrderActions } from '../../interfaces/order.interface';

export interface IAgGridDropdownMenuOption {
  label :string;
  icon :string;
  action ?:string;
  visible ?:boolean | ((row :any) => boolean);
  permissions ?:string[];
  featureFlags ?:string[];
  onRowClick ?:(row :any) => void;
}

export interface IAgGridDropdownMenuCellRendererParams extends ICellRendererParams {
  options :IAgGridDropdownMenuOption[];
  actionSelected :(data :IAgGridDropdownActionEvent) => void;
}

export interface IAgGridDropdownActionEvent {
  action :string;
  data :any;
}

@Component({
  selector: 'lum-ag-grid-dropdown-menu-cell-renderer',
  templateUrl: './ag-grid-dropdown-menu-cell-renderer.component.html',
  styleUrls: ['./ag-grid-dropdown-menu-cell-renderer.component.scss'],
})
export class AgGridDropdownMenuCellRendererComponent
  implements ICellRendererAngularComp
{
  options :IAgGridDropdownMenuOption[] = [];
  params :IAgGridDropdownMenuCellRendererParams;
  filteredOptions :IAgGridDropdownMenuOption[] = [];
  trackByLabel = trackByLabel;

  agInit(params :IAgGridDropdownMenuCellRendererParams) :void {
    this.params = params;
    this.options = this.params.options;
    this.updateFilteredOptions();
  }

  refresh(params :ICellRendererParams) :boolean {
    return false;
  }

  trackByAction(index :number, option :IAgGridDropdownMenuOption) :string {
    return option.action;
  }

  private updateFilteredOptions() :void {
    this.filteredOptions = this.options.filter((option) => {
      if (option.visible === undefined) return true; // Default to true if `visible` is not specified

      return typeof option.visible === 'function'
        ? option.visible(this.params.data)
        : option.visible;
    });
  }
}
